module.exports = __webpack_public_path__ + "static/img/img_left.c7bc689.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/navbar/img_left.png
// module id = f6xf
// module chunks = 4